export default "__VITE_ASSET__DxIdAJ99__"